(() => {
  if (window.novieAccordion) return;
  const phone = window.matchMedia('(max-width: 749px)');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  const summaryOf = (item) => item.querySelector(':scope > summary');

  const stop = (item) => {
    if (!item.slide) return;
    item.slide.cancel();
    item.slide = null;
  };

  const slide = (item, from, to, done) => {
    stop(item);
    const finish = () => {
      item.slide = null;
      item.style.overflow = '';
      done();
    };
    if (from === to || still.matches) {
      finish();
      return;
    }
    item.style.overflow = 'hidden';
    item.slide = item.animate(
      { height: [`${from}px`, `${to}px`] },
      { duration: 360, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
    );
    item.slide.onfinish = finish;
  };

  const open = (item) => {
    const from = item.offsetHeight;
    stop(item);
    item.dataset.state = 'opening';
    item.open = true;
    slide(item, from, item.offsetHeight, () => delete item.dataset.state);
  };

  const close = (item) => {
    const from = item.offsetHeight;
    stop(item);
    item.dataset.state = 'closing';
    const style = getComputedStyle(item);
    const edges =
      item.offsetHeight - item.clientHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
    slide(item, from, summaryOf(item).offsetHeight + edges, () => {
      item.open = false;
      delete item.dataset.state;
    });
  };

  const sync = () => {
    document.querySelectorAll('details[data-accordion="phone"]').forEach((item) => {
      stop(item);
      item.style.overflow = '';
      delete item.dataset.state;
      item.open = !phone.matches;
      summaryOf(item).tabIndex = phone.matches ? 0 : -1;
      item.dataset.ready = '';
    });
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('summary');
    const item = summary && summary.parentElement;
    if (!item || !item.matches('details[data-accordion]') || summaryOf(item) !== summary) return;
    event.preventDefault();
    if (item.dataset.accordion === 'phone' && !phone.matches) return;
    if (item.open && item.dataset.state !== 'closing') {
      close(item);
      return;
    }
    open(item);
  });

  phone.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();
  window.novieAccordion = { open, close };
})();
